module.exports = "/images/vendor/flag-icon-css/flags/1x1/km.svg?eb69abb632453975c98bae4443c14d2f";